import React from 'react'
import '../styles/drinkCampaignGrid.css';
import '../styles/GraphicDesign.css';
import '../styles/imageSlider.css';
import DrinkCampaignDisplay from '../components/drinkCampaign';
import AltNav from '../components/AltNav.js';

const DrinkCampaignPage = () => {
  return (
    <div>
      <AltNav />
      <header style={{ backgroundImage: `url('images/skyline2.png')` }} className='vertical-gradient texture1 header-alt' >
        <h1 className='heading3'>Drink Campaign</h1>
      </header>
      <section className="drink-campaign">

        <div id="drink-campaign-description">
          <div id="drink-camp-mobile">
            <img id="cups-icon-mobile" src={process.env.PUBLIC_URL + "/project-images/drinkicon.png"}
              alt="drinks icon of two cups"></img>
            <h1 id="drink-campaign-heading-1-mobile">DRINK CAMPAIGN</h1>
          </div>
          <div id="drink-campaign-description-1">
            <img id="pepsi-earth" src={process.env.PUBLIC_URL + "/project-images/2.jpg"}></img>
          </div>
          <div id="drink-campaign-description-2">
            <div id="drink-camp">
              <img id="cups-icon" src={process.env.PUBLIC_URL + "/project-images/drinkicon.png"}
                alt="drinks icon of two cups"></img>
              <h1 id="drink-campaign-heading-1">DRINK CAMPAIGN</h1>
            </div>
            <p> This is my drink campaign project. It was for a fine arts graphic design class that I Really
              enjoyed. I created this project mostly in illustrator and In Design, but I put the templates for
              the cans, tshirts, and the poster together in photoshop.</p>
            <p> For this project, we were able to chose any drink company and create a concept advertisement
              campaign. The campaign also had to be for a social cause. I chose Earth day and Pepsi. I felt
              the Pepsi logo was perfect for an Earth Day related campaign. We were required to create the
              design for the can on all sides of it. Additionally, we also had to create combo graphics and
              use photoshop templates to create the can and poster. I had extra time so I also made tshirt
              templates. </p>
            <p> This project was a lot of fun because it combined creative freedom with a very real world
              application of skills. I learned a lot and had fun with this one.</p>
          </div>
        </div>
        <div className='drinkcampaign-content'>
          <DrinkCampaignDisplay />
        </div>

      </section>
    </div>
  )
}

export default DrinkCampaignPage